function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 3.5A1.5 1.5 0 0016.5 2h-13A1.5 1.5 0 002 3.5v2a1.5 1.5 0 001 1.415V14.5A3.5 3.5 0 006.5 18h3.757a5.503 5.503 0 01-.657-1H6.5A2.5 2.5 0 014 14.5V7h12v2.207c.349.099.683.23 1 .393V6.914A1.5 1.5 0 0018 5.5v-2zM3.5 3h13a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5zm8.489 6.605A.502.502 0 0011.5 9h-3l-.09.008A.5.5 0 008.5 10h2.837c.207-.146.425-.278.652-.395z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 18c.363 0 .656-.29.656-.649v-5.136l1.724 1.703a.662.662 0 00.928 0 .643.643 0 000-.917l-2.844-2.811a.662.662 0 00-.928 0L11.192 13a.643.643 0 000 .918.662.662 0 00.928 0l1.724-1.703v5.136c0 .359.294.649.656.649z"
});

function SvgUnArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgUnArchive;